import { useState } from "react";
import { useNavigate } from "react-router-dom";
import APIAxios from "../../Api/APIAxios";
import Copyright from "../../components/Layout/Copyright";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { validarEmail } from "../../Components/Funcionais/Utils";
import {
  Grid,
  Paper,
  Avatar,
  Typography,
  TextField,
  Button,
  CssBaseline,
  Box,
  Stack,
  Alert,
  CircularProgress,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/Lock";

const defaultTheme = createTheme();

export default function AlterarSenha() {
  const [form, setForm] = useState({ email: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState(false);

  const navigate = useNavigate();

  const logosys = new URL("../../assets/Logosys.png", import.meta.url).href;
  const apiAxios = APIAxios();

  const handleChange = (e) => {
    setEmailError(false);
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleValidarEmail = (email) => {
    if (!validarEmail(email)) {
      setEmailError(true);
      return false;
    } else {
      setEmailError(false);
    }
    return true;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.email) {
      setError("Por favor, insira seu email.");
      return;
    }

    if (!handleValidarEmail(form.email)) {
      return;
    }

    setError("");
    setLoading(true);

    try {
      const response = await apiAxios.post("/lembrarsenha", {
        email: form.email,
      });


      if (response.status === 200) {
        navigate("/enviado");
      } else {
        setError("Erro ao enviar email. Tente novamente.");
      }
    } catch (err) {
      setError("Erro ao enviar email. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };


  return (
    <ThemeProvider theme={defaultTheme}>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />


        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: `url(${logosys})`,
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "left",
          }}
        />

        <Grid
          item
          xs={12}
          sm={8}
          md={5}
          component={Paper}
          elevation={6}
          square
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            px: { xs: 3, sm: 6 },
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "#00597A" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Lembrar Senha
          </Typography>

          {error && (
            <Stack sx={{ width: "100%", mt: 2 }} spacing={1}>
              <Alert severity="error">{error}</Alert>
            </Stack>
          )}

          <Box
            component="form"
            noValidate
            sx={{
              mt: 1,
              width: "100%",
              maxWidth: 400
            }}
          >
            <TextField
              variant="outlined"
              margin="normal"
              error={emailError}
              helperText={emailError ? "Formato de email inválido." : ""}
              required
              fullWidth
              label="E-mail"
              name="email"
              value={form.email}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />

            <Grid
              xs={12}
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 2,
              }}
            >
              {/* Botões lado a lado */}
              <Box sx={{ display: "flex", width: "48%" }}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  sx={{ position: "relative", backgroundColor: "#00597A" }}
                  onClick={(e) => handleSubmit(e)}
                >
                  Enviar Email
                  {loading && (
                    <CircularProgress
                      size={35}
                      sx={{
                        color: "#dcdcdc",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 1,
                      }}
                    />
                  )}
                </Button>
              </Box>

              <Box sx={{ display: "flex", width: "48%" }}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  sx={{ position: "relative", backgroundColor: "#00597A" }}
                  onClick={() => navigate("/login")}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
          </Box>
          <Copyright sx={{ mt: 5 }} />
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
